import React from "react";
import { Card, CardTitle, CardBody, Typography, Link } from "@one-thd/sui-atomic-components";

interface HeaderConfig {
  variant?: string;
  weight?: string;
  className?: string;
  text: string;
}

interface ActionConfig {
  href: string;
  className?: string;
  text: string;
}

interface CardTitleConfig {
  header?: HeaderConfig;
  action?: ActionConfig;
  [key: string]: any; // for additional titleProps
}

interface Card {
  className?: string;
  [key: string]: any;
}

interface WithCardOptions {
  card?: Card;
  cardBody?: Card;
  cardTitle?: CardTitleConfig;
}

const ConfiguredCardTitle = ({ cardTitleConfig }: { cardTitleConfig: CardTitleConfig }) => {

  const { header, action, ...titleProps } = cardTitleConfig;

  let headerElement = null;
  if (header) {
    const { variant, weight, className, text, ...restHeaderProps } = header;
    headerElement = (
      <Typography
        variant={variant || "h3"}
        weight={weight || "regular"}
        className={className}
        {...restHeaderProps}
      >
        {text}
      </Typography>
    );
  }

  let actionElement = null;
  if (action) {
    actionElement = (
      <Link href={action.href} className={action.className}>
        {action.text}
      </Link>
    );
  }

  return (
    <CardTitle
      header={headerElement}
      action={actionElement}
      {...titleProps}
    />
  );
};

export const withCard = (WrappedComponent: any, options: WithCardOptions) => {
  const CardWrapper = (props: any) => {
    const { card = {}, cardBody: cardBodyProps, cardTitle } = options || {};

    const cardProps = {
      className: "sui-h-full",
      ...card,
    };

    return (
      <Card {...cardProps}>
        {cardTitle && <ConfiguredCardTitle cardTitleConfig={cardTitle} />}
        <CardBody {...cardBodyProps}>
          <WrappedComponent {...props} />
        </CardBody>
      </Card>
    );
  };
  CardWrapper.dataModel = WrappedComponent.dataModel || {};
  CardWrapper.wraps = { ...(WrappedComponent.wraps || {}), card: true };
  CardWrapper.$$typeof = WrappedComponent.$$typeof;
  CardWrapper.displayName = WrappedComponent.displayName;

  return CardWrapper;
};
